/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pageable } from '../models/Pageable';
import type { PageRestrictedWordLogResponse } from '../models/PageRestrictedWordLogResponse';
import type { RestrictedWordLog } from '../models/RestrictedWordLog';
import type { RestrictedWordLogFilter } from '../models/RestrictedWordLogFilter';
import type { RestrictedWordLogRequest } from '../models/RestrictedWordLogRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardRestrictedWordLogControllerService {
    /**
     * @returns RestrictedWordLog OK
     * @throws ApiError
     */
    public static dashboardAddRestrictedWordLog({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: RestrictedWordLogRequest,
    }): CancelablePromise<RestrictedWordLog> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/restricted-word-logs/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PageRestrictedWordLogResponse OK
     * @throws ApiError
     */
    public static dashboardGetRestrictedWordLogs({
        filter,
        pageable,
    }: {
        filter: RestrictedWordLogFilter,
        pageable: Pageable,
    }): CancelablePromise<PageRestrictedWordLogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/restricted-word-logs',
            query: {
                'filter': filter,
                'pageable': pageable,
            },
        });
    }
}
